import React from "react";
import { Box, CircularProgress } from "@mui/material";

import { Colors } from "../utils/colors";

export default function TableLoadingOverlay({ loading }) {
  if (!loading) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.6)",
        backdropFilter: "blur(2px)",
        zIndex: 2,
        borderRadius: 1
      }}
    >
      <CircularProgress size={44} sx={{ color: Colors.accent }} />
    </Box>
  );
}
